module.exports = __webpack_public_path__ + "media/images/18px_emptystar-68aabd9fc11b8017f2e484ef5bd1d1b4f4622834510c902cc57e06b41044da16.png";